export const Dashboard = 'dashboard';

export const Company = '/dashboard/company'
export const CompanyList = '/dashboard/company/company-list';
export const CompanyDetail = '/dashboard/company/company-detail';
export const CompanyRegister = '/dashboard/company/company-register';
export const CompanyRegistration = '/dashboard/company/company-registration';
export const CompanyEdit = '/dashboard/company/company-edit';

export const Vessel = '/dashboard/vessel';
export const VesselList = '/dashboard/vessel/vessel-list';
export const VesselDetail = '/dashboard/vessel/vessel-detail';
export const VesselRegister = '/dashboard/vessel/vessel-register';
export const VesselEdit = '/dashboard/vessel/vessel-edit';
export const VesselApplicationRegister = '/dashboard/vessel/vessel-application-register'
export const VesselRegistration = '/dashboard/vessel/vessel-registration';

export const User = '/dashboard/user';
export const UserList = '/dashboard/user/user-list';
export const UserRegister = '/dashboard/user/user-register';
export const UserEdit = '/dashboard/user/user-edit';
export const UserPreview = '/dashboard/user/user-preview';
export const UserRegistration = '/dashboard/user/user-registration';

export const Tenant = '/dashboard/tenant'
export const TenantList = '/dashboard/tenant/tenant-list';
export const TenantEdit = '/dashboard/tenant/tenant-edit';
export const TenantRegister = '/dashboard/tenant/tenant-register';
export const TenantRegistration = '/dashboard/tenant/tenant-registration';

export const Meetings = '/dashboard/meetings/join-a-room';
export const Room = '/dashboard/meetings/room';
export const Calendar = '/dashboard/meetings/calendar'

export const ClaimCenter = '/dashboard/claim-center/dashboard';
export const ClaimEdit = '/dashboard/claim-center/claim-edit';

export const InquiryCenter = '/dashboard/inquiry-center/dashboard';
export const InquiryEdit = '/dashboard/inquiry-center/claim-edit';